import { useContext } from 'react';
import { EmailCampaignContext } from './EmailCampaignProvider';

export const useEmailCampaign = () => {
  const context = useContext(EmailCampaignContext);

  if (!context) {
    throw new Error('useEmailCampaign must be used within EmailCampaignProvider');
  }

  return context;
};
